"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.create = void 0;
var crokinoleScene_create_sidecar_1 = require("./crokinoleScene_create-sidecar");
var crokinoleScene_update_sidecar_1 = require("./crokinoleScene_update-sidecar");
var create = function () {
    crokinoleScene_create_sidecar_1.crokinoleScene_create.create();
};
exports.create = create;
var update = function (time, delta) {
    crokinoleScene_update_sidecar_1.crokinoleScene_update.update(time, delta);
};
exports.update = update;
